// @flow

import type { Action } from './store.type';

type KlaviyosSuccess = {
  data: any
};

type KlaviyoFailure = {
  error: any
};

/* #region: Get klaviyo status */
export const GET_KLAVIYO_STATUS_REQUEST = 'GET_KLAVIYO_STATUS_REQUEST';
type GET_KLAVIYO_STATUS_REQUEST_TYPE = 'GET_KLAVIYO_STATUS_REQUEST';

export const GET_KLAVIYO_STATUS_SUCCESS = 'GET_KLAVIYO_STATUS_SUCCESS';
type GET_KLAVIYO_STATUS_SUCCESS_TYPE = 'GET_KLAVIYO_STATUS_SUCCESS';

export const GET_KLAVIYO_STATUS_FAILURE = 'GET_KLAVIYO_STATUS_FAILURE';
type GET_KLAVIYO_STATUS_FAILURE_TYPE = 'GET_KLAVIYO_STATUS_FAILURE';

type GetKlaviyoStatusRequestAction = Action<GET_KLAVIYO_STATUS_REQUEST_TYPE, null>;

type GetKlaviyoStatusSuccessAction = Action<GET_KLAVIYO_STATUS_SUCCESS_TYPE, KlaviyosSuccess>;

type GetKlaviyoStatusFailureAction = Action<GET_KLAVIYO_STATUS_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: Generate klaviyo link  */
export const GENERATE_KLAVIYO_LINK_REQUEST = 'GENERATE_KLAVIYO_LINK_REQUEST';
type GENERATE_KLAVIYO_LINK_REQUEST_TYPE = 'GENERATE_KLAVIYO_LINK_REQUEST';

export const GENERATE_KLAVIYO_LINK_SUCCESS = 'GENERATE_KLAVIYO_LINK_SUCCESS';
type GENERATE_KLAVIYO_LINK_SUCCESS_TYPE = 'GENERATE_KLAVIYO_LINK_SUCCESS';

export const GENERATE_KLAVIYO_LINK_FAILURE = 'GENERATE_KLAVIYO_LINK_FAILURE';
type GENERATE_KLAVIYO_LINK_FAILURE_TYPE = 'GENERATE_KLAVIYO_LINK_FAILURE';

type GenerateKlaviyoLinkAction = Action<GENERATE_KLAVIYO_LINK_REQUEST_TYPE, null>;

type GenerateKlaviyoLinkSuccessAction = Action<GENERATE_KLAVIYO_LINK_SUCCESS_TYPE, KlaviyosSuccess>;

type GenerateKlaviyoLinkFailureAction = Action<GENERATE_KLAVIYO_LINK_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: Oauth klaviyo callback  */
export const OAUTH_KLAVIYO_REQUEST = 'OAUTH_KLAVIYO_REQUEST';
type OAUTH_KLAVIYO_REQUEST_TYPE = 'OAUTH_KLAVIYO_REQUEST';

export const OAUTH_KLAVIYO_SUCCESS = 'OAUTH_KLAVIYO_SUCCESS';
type OAUTH_KLAVIYO_SUCCESS_TYPE = 'OAUTH_KLAVIYO_SUCCESS';

export const OAUTH_KLAVIYO_FAILURE = 'OAUTH_KLAVIYO_FAILURE';
type OAUTH_KLAVIYO_FAILURE_TYPE = 'OAUTH_KLAVIYO_FAILURE';

type OauthKlaviyoAction = Action<OAUTH_KLAVIYO_REQUEST_TYPE, null>;

type OauthKlaviyoSuccessAction = Action<OAUTH_KLAVIYO_SUCCESS_TYPE, KlaviyosSuccess>;

type OauthKlaviyoFailureAction = Action<OAUTH_KLAVIYO_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: Toggle klaviyo  */
export const TOGGLE_KLAVIYO_REQUEST = 'TOGGLE_KLAVIYO_REQUEST';
type TOGGLE_KLAVIYO_REQUEST_TYPE = 'TOGGLE_KLAVIYO_REQUEST';

export const TOGGLE_KLAVIYO_SUCCESS = 'TOGGLE_KLAVIYO_SUCCESS';
type TOGGLE_KLAVIYO_SUCCESS_TYPE = 'TOGGLE_KLAVIYO_SUCCESS';

export const TOGGLE_KLAVIYO_FAILURE = 'TOGGLE_KLAVIYO_FAILURE';
type TOGGLE_KLAVIYO_FAILURE_TYPE = 'TOGGLE_KLAVIYO_FAILURE';

type ToggleKlaviyoAction = Action<TOGGLE_KLAVIYO_REQUEST_TYPE, null>;

type ToggleKlaviyoSuccessAction = Action<TOGGLE_KLAVIYO_SUCCESS_TYPE, KlaviyosSuccess>;

type ToggleKlaviyoFailureAction = Action<TOGGLE_KLAVIYO_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

/* #region: Update klaviyo banner  */
export const UPDATE_KLAVIYO_BANNER_REQUEST = 'UPDATE_KLAVIYO_BANNER_REQUEST';
type UPDATE_KLAVIYO_BANNER_REQUEST_TYPE = 'UPDATE_KLAVIYO_BANNER_REQUEST';

export const UPDATE_KLAVIYO_BANNER_SUCCESS = 'UPDATE_KLAVIYO_BANNER_SUCCESS';
type UPDATE_KLAVIYO_BANNER_SUCCESS_TYPE = 'UPDATE_KLAVIYO_BANNER_SUCCESS';

export const UPDATE_KLAVIYO_BANNER_FAILURE = 'UPDATE_KLAVIYO_BANNER_FAILURE';
type UPDATE_KLAVIYO_BANNER_FAILURE_TYPE = 'UPDATE_KLAVIYO_BANNER_FAILURE';

type UpdateKlaviyoBannerAction = Action<UPDATE_KLAVIYO_BANNER_REQUEST_TYPE, null>;

type UpdateKlaviyoBannerSuccessAction = Action<UPDATE_KLAVIYO_BANNER_SUCCESS_TYPE, KlaviyosSuccess>;

type UpdateKlaviyoBannerFailureAction = Action<UPDATE_KLAVIYO_BANNER_FAILURE_TYPE, KlaviyoFailure>;
/* #endregion */

export const KLAVIYO_STATUS = {
  VERIFYING: 'verifying',
  ACTIVE: 'active',
  REMOVED: 'removed',
  INACTIVE: 'inactive'
};

// Action and State
export type KlaviyoAction =
  | GetKlaviyoStatusRequestAction
  | GetKlaviyoStatusSuccessAction
  | GetKlaviyoStatusFailureAction
  | GenerateKlaviyoLinkAction
  | GenerateKlaviyoLinkSuccessAction
  | GenerateKlaviyoLinkFailureAction
  | OauthKlaviyoAction
  | OauthKlaviyoSuccessAction
  | OauthKlaviyoFailureAction
  | ToggleKlaviyoAction
  | ToggleKlaviyoSuccessAction
  | ToggleKlaviyoFailureAction
  | UpdateKlaviyoBannerAction
  | UpdateKlaviyoBannerSuccessAction
  | UpdateKlaviyoBannerFailureAction;
